import './MealCard.css'

import React from 'react';
import { useNavigate } from 'react-router-dom';

import { AiFillFire } from "react-icons/ai";
import { PiPlantFill } from "react-icons/pi";
import { LuWheat } from "react-icons/lu";
import { GiMeat } from "react-icons/gi";
import { RiGitRepositoryPrivateFill } from "react-icons/ri";

function MealCard({ item, wantSmall, customMealCardFunction }) {

    const navigate = useNavigate();
    const moveToAnotherMeal = (mealid) => {
        navigate(`/meal-details/${mealid}`);
        window.scrollTo({
            top: 0,
            behavior: 'smooth' // Optional: adds smooth scrolling animation
        });
    };

    function removeAfterDot(str) {
        if (typeof str === 'string') {
            const dotIndex = str.indexOf('.');
            if (dotIndex === -1) {
                return str; // Return the original string if no dot is found
            }
            return str.slice(0, dotIndex);
        } else return str
    }


    return (
        <div key={item.meal_id} className={wantSmall ? 'meal_slider_item_small' : 'meal_slider_item'} onClick={() => customMealCardFunction ? customMealCardFunction(item) : moveToAnotherMeal(item.meal_id)}>
            <div style={{ position: 'relative' }}>
                < img src={item.image} />
                <div style={{
                    position: 'absolute',
                    top: '10px',  // Adjust as needed
                    left: '10px', // Adjust as needed
                    color: 'white', // Change icon color if needed
                    fontSize: '24px', // Adjust size if necessary
                }}
                >
                    {
                        item.private && <div className='meal_slider_item_lock_icon'>
                            <RiGitRepositoryPrivateFill color='#FFCB9E' />
                        </div>
                    }

                </div>
            </div>
            <span className='meal_slider_item_bottom'>

                <span className='font_size_24 font_family_ovo font_weight_400 gray_scale_6'>
                    {item.name}
                </span>
                <div className={wantSmall ? 'meal_slider_item_stats_small' : 'meal_slider_item_stats'}>
                    <div style={{ width: '100%' }} className={'flex justify_space_between' + (wantSmall ? ' flex_column gap_10' : '')}>
                        <div className='flex gap_8 meal_slider_item_stat_indiv'>
                            <AiFillFire color='#FE9539' size={20} />
                            <p className='font_size_14 font_family_inter font_weight_400 gray_scale_6'>
                                {removeAfterDot(item.total_calories)} Cals
                            </p>
                        </div>
                        <div className='flex gap_8 meal_slider_item_stat_indiv '>
                            <GiMeat color='#5A5855' size={20} />
                            <p className='font_size_14 font_family_inter font_weight_400 gray_scale_6'>
                                {removeAfterDot(item.total_protein)}g Protein
                            </p>
                        </div>
                    </div>
                    {!wantSmall && <span style={{ width: '100%' }} className='flex justify_space_between'>
                        <div className='flex gap_8 meal_slider_item_stat_indiv '>
                            <PiPlantFill color='#235539' size={20} />
                            <p className='font_size_14 font_family_inter font_weight_400 gray_scale_6'>
                                {removeAfterDot(item.total_fiber)}g Fiber
                            </p>
                        </div>
                        <div className='flex gap_8 meal_slider_item_stat_indiv'>
                            <LuWheat color='#FE9539' size={20} />
                            <p className='font_size_14 font_family_inter font_weight_400 gray_scale_6'>
                                {removeAfterDot(item.total_carb)} Carbs
                            </p>
                        </div>
                    </span>}

                </div>
            </span>

        </div >
    );
}

export default MealCard;
